import React from "react";
import "../customcss.css";
import "./Product";
import "./ProjectArch";
import "./paintingSlider";
import "./Contact";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <header className=" bg-gray-800  z-0 ">
      <div className="center navheader">
        <a className="title-font font-medium text-white mb-4 md:mb-0">
          <a href="/" className="ml-3 text-xl">
            NatTK
          </a>
        </a>
        <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 sm:mb-0">
          <Link to="/Architecture" className="mr-5 hover:text-white">
            Architect
          </Link>
          <Link to ="/ProductDesign" className="mr-5 hover:text-white">
            Designer
          </Link>
          <Link to="/Developer" className="mr-5 hover:text-white">
            Developer          
        </Link>
        </nav>
      </div>
    </header>
  );
}
